import { formatDate } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PcsFilterCriteriaforHighlight } from '../../../common/models/PendingIntegeration';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { SessionService } from '../../../common/services/Session.service';
import { LoginService } from '../../../common/services/Login.service';
@Component({
  selector: 'app-pending-content-page-viewer',
  templateUrl: './pending-content-page-viewer.component.html',
  styleUrls: ['./pending-content-page-viewer.component.css']
})
export class PendingContentPageViewerComponent implements OnInit, OnDestroy {
  @Input() RightOverlay: boolean = false;
  @Input() RightOverlayPageData = {
    pubId: "",
    pageId: "",
    paraId: ""
  };
  title: string = "";
  body;
  publicationId
  pageId;
  pageName: string = "";
  paragraphTitleContent: any[] = [];
  paragraphs: string[];
  paragraphContent = [];
  paragraphContent_Pending = [];
  pageHeading;
  paragraphIdsList: any[] = [];
  paraArticleId: string = "";
  addedparagraphList = [];
  event$
  pageUrl: string = "";
  PendingContentPage: boolean = true;
  PendingContentParagraph = ""
  version: string = "";
  versionDate: string = "";
  FiscalDate: any;
  PeriodType: string;
  fillingStatus: string;
  periodTypeLabel: any;
  paragraphIdHighlight: any
  s3ImageBasePath: string = "";
  @Output() myEvent = new EventEmitter<string>();
  constructor(
    private commonDataService: CommonDataService, private loginService: LoginService,
    private graphQLService: GraphqlService, private router: Router, private sanitizer: DomSanitizer, private session: SessionService) {
  }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.PendingContentPage = true;
    this.getUserId();
    this.graphQLService.getS3BucketImagePath().subscribe(data => { this.s3ImageBasePath = data; });
    if (this.RightOverlay) {
      this.loadPendingDatafromSession();
    }
    //else {
    //  this.loadPendingDataForContentPage()
    //}
  }
  getUserId() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.MapLoginData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.MapLoginData(this.session.userInfo);
    }
  }
  loggedInUserInfo;
  MapLoginData(loginData) {
    if (loginData != null) {
      this.loggedInUserInfo = loginData;
    }
  }
  eventHandler() {
    this.myEvent.emit();
  }
  search: PcsFilterCriteriaforHighlight = new PcsFilterCriteriaforHighlight();
  validPendingData: boolean = true;
  loadPendingDatafromSession() {
    this.graphQLService.GetPendingIntegrationSession().subscribe(data => {
      if (data != "" && data) {
        this.FiscalDate = "Fiscal year beginning " + formatDate(data?.selectedDate, 'MM/dd/yyyy', 'en-US');
        this.fillingStatus = data?.selectedFillingStatus;
        this.PeriodType = data?.selectedPeriodType;
        this.getPCSLabels();
      }
    });
    this.graphQLService.GetBreadcrumbSession(this.RightOverlayPageData.pubId + "/" + this.RightOverlayPageData.pageId).subscribe(breadcrumbData => {
      if (breadcrumbData !== null) {
        this.navData = JSON.parse(JSON.stringify(breadcrumbData));
        this.setTopicSubtopicNum();
        if (this.navData.crumbData != null) {
          this.validPendingData = true;
          this.getPageContent(this.RightOverlayPageData.pubId, this.RightOverlayPageData.pageId, this.navData.crumbData[this.navData.crumbData.length - 1]);
        }
        else {
          this.commonDataService.showLoader.next(false);
          this.validPendingData = false;
        }
      }
    });
  }
  navData;

  //getBreadCrumb() {
  //  this.publicationId = this.RightOverlay ? this.RightOverlayPageData.pubId : this.search.publicationId;
  //  this.pageId = this.RightOverlay ? this.RightOverlayPageData.pageId : this.search.pageId;
  //  let url = this.publicationId + "/" + this.pageId;
  //  this.graphQLService.GetBreadcrumbSession(url).subscribe(data => {
  //    if (data !== null) {
  //      this.navData = JSON.parse(JSON.stringify(data));
  //    }
  //  });
  //}
  paraid: string;
  setTopicSubtopicNum() {
    if (this.navData.crumbData != null) {
      this.paraid = "";
      for (let i = 1; i <= this.navData.crumbData.length - 2; i++) {
        if (this.navData.crumbData[i].split(" ")[0] != '' && !(this.navData.crumbData[i].split(" ")[0]).includes("X")) {
          this.paraid += this.navData.crumbData[i].split(" ")[0] + "-";
        }
      }
      this.topic_subtopicNum = this.paraid;
    }
  }
  topic_subtopicNum: string = "";
  ngOnDestroy(): void {
    localStorage.removeItem("archiveVersionInput");
  }

  sectionHeader: string = "";
  fillingStatus_Label: string = "";
  showingContent_Label: string = "";
  getPCSLabels() {
    this.graphQLService.getPendingContentSystemLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.sectionHeader = labels.filter(x => x.key == "pc_contentheader").map(y => y.value);
        this.periodTypeLabel = labels.filter(x => x.key == "pc_periodType").map(y => y.value);
        this.fillingStatus_Label = labels.filter(x => x.key == "pc_filingStatus").map(y => y.value);
        this.showingContent_Label = labels.filter(x => x.key == "pc_Showingcontent_label").map(y => y.value);
      }
    });
  }

  topicBodyContent: any = [];
  apiResponse: any;
  getPageContent(publicationId: string, pageId: string, pageName: string) {
    var pageHeader = {"publicationId": publicationId, "pageId": pageId, "pageName": pageName, "pageNavPath": "", "PendingContentIntegrationData": [] };
    forkJoin([
      this.graphQLService.getPageData(pageHeader),
      this.graphQLService.GetPendingContentMergeList(publicationId, pageId)
    ]).subscribe(([result, resultPendingContent]) => {
      this.topicBodyContent = result.topicBodyContent;
      this.apiResponse = result;
      //this.pageInfoMapping(this.apiResponse);
      this.paragraphTitleContent = result.formattedResponse;
      this.title = result.contentPageTitle;
      //this.topicBodyContent = this.apiResponse.contentPageInfo;
      this.getParagraphs(this.apiResponse);
      this.loadPendingData(resultPendingContent);
    }, err => {
      console.log(err);
    });
  }
  PendingContentMergeList: any[];
  loadPendingData(resultPendingContent) {
    if (resultPendingContent.isPCSIntegrated) {
      //to be uncommetted if para number should not be checked
      // this.PendingContentPage = resultPendingContent.isPCSIntegrated;
      if (resultPendingContent.pcsIntegrationData != null) {
        this.FiscalDate = "Fiscal year beginning " + formatDate(resultPendingContent.date, 'MM/dd/yyyy', 'en-US');
        this.fillingStatus = resultPendingContent.filingStatus;
        this.PeriodType = resultPendingContent.periodtype;
        this.getPCSLabels();

        this.PendingContentMergeList = resultPendingContent.pcsIntegrationData;
        //condition to be removed and made  this.PendingContentPage = true if para number to be not considered
        this.PendingContentMergeList.length > 0 ? this.PendingContentPage = true : this.PendingContentPage = false;
      }
      else {
        //can be made true if para number should not be checked
        this.PendingContentPage = false;
      }
    }
  }
  pageInfoMapping(data) {
    this.topicBodyContent = [];
    data.contentPageInfo.forEach(info => {
      let obj = {
        PageInfoPosition: info.infoPosition,
        contentPageTitle: info.contentPageTitle,
        contentPageBody: this.sanitizer.bypassSecurityTrustHtml(info.contentPageBody)
      }
      this.topicBodyContent.push(obj);
    });
  }
  paraGroups: any[] = [];
  pgroups = [];
  pgroup;
  pgroupName: string = "";
  TopicTitle: string[];
  topicheader: string;
  TopicBody: string[];
  paragraph: string[];
  topicheader2: string;
  outcome: boolean = false;
  paraBody: string[] = [];
  paragraphArrayIds: string[] = [];
  annotationCountDictionary: string[] = [];
  bookmarkCountDictionary: string[] = [];
  paragraphNum: string[] = [];
  getParagraphs(response) {
    //this.paragraphContent = [];
    //this.paragraphTitleContent = [];
    //for (let l = 0; l < response.paraGroups.length; l++) {
    //  this.paragraphContent = [];
    //  for (let k = 0; k < response.paraGroups[l].pgroups.length; k++) {
    //    for (let i = 0; i < response.paraGroups[l].pgroups[k].paragraphArrayIds.length; i++) {
    //      if (i == 0) {
    //        let temp = {
    //          paragroup: response.paraGroups[l].pgroups[k].pgroupName,
    //          id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //          paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //          paraAnnotationCount: 0,
    //          paraBookmarkCount: 0,
    //          paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //          paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //          paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //          paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //          paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //          paraContent: this.sanitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //          PrintQueueAdded: false,
    //          actionLabel: []
    //        }
    //        this.paragraphContent.push(temp);
    //      }
    //      else {
    //        let temp = {
    //          paragroup: "",
    //          id: response.paraGroups[l].pgroups[k].paragraphArrayIds[i],
    //          paraNum: response.paraGroups[l].pgroups[k].paragraphNum[i],
    //          paraAnnotationCount: 0,
    //          paraBookmarkCount: 0,
    //          paraTitle: response.paraGroups[l].pgroups[k].paraBodyTitle[i],
    //          paraTitle2: response.paraGroups[l].pgroups[k].paraBodyTitle2[i],
    //          paraTitle3: response.paraGroups[l].pgroups[k].paraBodyTitle3[i],
    //          paraTitle4: response.paraGroups[l].pgroups[k].paraBodyTitle4[i],
    //          paraTitle5: response.paraGroups[l].pgroups[k].paraBodyTitle5[i],
    //          paraContent: this.sanitizer.bypassSecurityTrustHtml(response.paraGroups[l].pgroups[k].paraBody[i]),
    //          PrintQueueAdded: false,
    //          actionLabel: []
    //        }
    //        this.paragraphContent.push(temp);
    //      }

    this.PendingContentParagraph = this.RightOverlay ? this.RightOverlayPageData.paraId : this.paragraphIdHighlight;
    console.log(this.PendingContentParagraph);
    //this.paragraphContent_Pending = this.paragraphContent.filter(x => (x.paraNum == this.PendingContentParagraph))
    //this.paragraphContent = this.RightOverlay ? this.paragraphContent_Pending : this.paragraphContent;
    // }
    //  }
    //this.paragraphTitleContent.push({ title: response.paraGroups[l].title, paragraphContent: this.paragraphContent });
    //}
    this.outcome = true;
    this.commonDataService.showLoader.next(false);
    this.pageHeading = this.title;
  }

  BackToCurrentVersion() {
    this.router.navigateByUrl(this.pageUrl);
  }
}
